import { FormattedMessage, useIntl } from 'react-intl';
import styled from 'styled-components';

import { BodyM } from '#src/atoms/typography/index.tsx';

const Count = styled(BodyM)`
  white-space: nowrap;
`;
type Props = {
  count: number;
  shorten?: boolean;
};

export const SubscribersCount = ({ count, shorten }: Props) => {
  const { formatNumber } = useIntl();

  return (
    <Count as="p">
      {shorten ? (
        <span>{formatNumber(count, { notation: 'compact' })}</span>
      ) : (
        <FormattedMessage
          id="Follower.count"
          defaultMessage="{subscriptionsCount, number} {subscriptionsCount, plural, one {Follower} other {Followers}}"
          values={{ subscriptionsCount: count }}
        />
      )}
    </Count>
  );
};
